@if (showLoading()) {
    <div
        class="folding-cube-container"
        style="font-family: Roboto, sans-serif; height: 100%; display: flex; justify-content: center; align-items: center"
    >
        <div style="display: flex; flex-direction: row; align-items: center">
            <img alt="RaxBooker icoon" src="./assets/img/raxbooker_icon_32.png" style="margin: 0 auto; margin-right: 8px" />
            <p style="font-size: 2em">Rax<span style="font-weight: bold">Booker</span></p>
        </div>

        <div class="sk-folding-cube">
            <div class="sk-cube1 sk-cube"></div>
            <div class="sk-cube2 sk-cube"></div>
            <div class="sk-cube4 sk-cube"></div>
            <div class="sk-cube3 sk-cube"></div>
        </div>
        <h3>Authentication in progress ..</h3>
    </div>
} @else {
    <div style="position: absolute" class="h-full w-full flex items-center justify-center shell-page-background">
        <section style="padding: 24px 32px 32px 32px; border-radius: 4px; max-width: 400px" class="mat-elevation-z2 flex flex-col">
            <div style="margin-bottom: 16px" class="flex gap-4 items-center">
                <img alt="RaxBooker icoon" src="./assets/img/raxbooker_icon_32.png" />
                <h1 style="font-weight: normal">Rax<span style="font-weight: bold">Booker</span></h1>
            </div>
            <h3 style="margin: 0">Accounts</h3>
            @for (account of accounts(); track account.idToken) {
                <div class="flex items-center">
                    <button mat-button (click)="onSetActiveAccountButtonClick(account)" [title]="account.localAccountId">
                        {{ account.username }}
                    </button>
                    <button mat-icon-button (click)="onRemoveAccountButtonClick(account)"><mat-icon>delete</mat-icon></button>
                </div>
            }

            <button mat-raised-button (click)="onSignInWithDifferentAccountButtonClick()" style="margin-top: 16px">Log andere account in</button>
            <button mat-raised-button (click)="onSignOutAllAccountsButtonClick()" style="margin-top: 16px">Alle accounts uitloggen</button>
        </section>
    </div>
}
